<div class="container--padding">
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <h2 class="mt-5">{{ title | translate }}</h2>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex flex-row-reverse">
      <button class="button button--purple button--big listing--button mt-5" routerLink="/creation" [disabled]="loader">
        <span *ngIf="loader" type="button"><span class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
          <span translate>Loading</span></span><span *ngIf="!loader" translate>Create experience</span>
      </button>
    </div>
  </div>
  <div *ngIf="experiences" class="row mt-5">
    <div *ngFor="let experience of experiences; let i = index" class="col-xl-6 mb-4">
      <div class="experience__item">
        <h4 class="mb-4 d-flex">
          <span class="experience__item__title">{{
            experience.title
            }}</span>
          <div class="dropdown flex-row-reverse">
            <button class="btn btn--transparent dropdown-toggle" type="button" id="dropdownMenuButton"
              data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="button">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <span *ngIf="menuExp.editRejected" class="dropdown-item" (click)="editRejected(experience)"
                translate>Edit</span>
              <span *ngIf="menuExp.editPublished" class="dropdown-item" (click)="editPublished(experience)"
                translate>Edit</span>
              <span *ngIf="menuExp.edit" class="dropdown-item" (click)="edit(experience)" translate>Edit</span>
              <span *ngIf="menuExp.qr" class="dropdown-item" (click)="getQr(experience)" translate>Download QR</span>
              <span *ngIf="menuExp.bin" class="dropdown-item" (click)="binExperience(experience, i)" translate>Move to
                bin</span>
              <span *ngIf="menuExp.binDraft" class="dropdown-item" (click)="binExperienceCancel(experience, i)"
                translate>Move to bin</span>
              <span *ngIf="menuExp.restore" class="dropdown-item" (click)="restore(experience, i)"
                translate>Restore</span>
              <span *ngIf="menuExp.delete" class="dropdown-item" (click)="deleteExperience(experience, i)"
                translate>Delete</span>
            </div>
          </div>
        </h4>

        <div *ngIf="experience.coverImage" [style.background-image]="
            'url(' + experience.coverImage?.original + ')'
          " class="experience__image">
          <div class="experience__image__overlay"></div>
        </div>
        <div *ngIf="!experience.coverImage" class="experience__image">
          <div class="experience__image__overlay"></div>
        </div>
        
          <div class="col-xl-12">
            <div class="col-xl-12 py-3">
              <span>{{ experience?.addressText || "No address" }}</span>
            </div>
          </div>
        <div class="experience__categories">
          <span class="experience__categorie active-list {{ cat }}" *ngFor="let cat of experience.types">{{ cat |
            translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="noRecords" class="welcome__screen">
    <div class="welcome__screen__figure col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-5"></div>
    <p>{{ noRecordWording | translate }}</p>
  </div>

  <button *ngIf="hideLoader" type="button" class="button button--purple button--big button--more mt-5"
    (click)="getMoreExperiences()" [disabled]="loaderMore || loadingMoreEmpty">
    <span *ngIf="loaderMore && !loadingMoreEmpty"><span class="spinner-border spinner-border-sm" role="status"
        aria-hidden="true"></span>
      <span translate>Loading</span></span><span *ngIf="!loaderMore && !loadingMoreEmpty" translate>Load
      more</span><span *ngIf="loadingMoreEmpty" translate>No more experiences</span>
  </button>
</div>